// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.coupon_couponDatatableList__ys2nO {
    padding: 30px 30px 0;
}

.coupon_couponHeader__zzawK {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.coupon_couponHeader__zzawK .coupon_couponHeading__GSuK1 {
    font-size: 20px;
    font-weight: 600;
}

.coupon_actionButtonsDeleteAdd__388aa {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
}

.coupon_couponHeader__zzawK .coupon_leftSide__C8WOZ {
    display: flex;
    gap: 20px;
}

.coupon_searchBar__YAsTt {
    display: flex;
    align-items: center;
    border: 1px solid #ddd;
    border-radius: 6px;
    padding: 8px 12px;
    gap: 8px;
    min-width: 250px;
    height: 40px;
}

.coupon_searchBar__YAsTt img {
    width: 16px;
    height: 16px;
}

.coupon_searchBar__YAsTt input {
    border: none;
    background: transparent;
    outline: none;
    flex: 1 1;
    font-size: 14px;
    color: #333;
}

.coupon_searchBar__YAsTt input::placeholder {
    color: #999;
}

.coupon_addCouponContainer__8N13N {
    padding: 25px 25px 0;
    display: flex;
    flex-direction: column;
    gap: 25px;
    height: 100vh;
}

.coupon_couponGenerateSection__4Q86h {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    gap: 5px;
    width: 100%;
}

.coupon_couponInput__sNX7B {
    width: 100%;
    padding: 10px;
    font-size: 16px;
    border: 1px solid #ddd;
    border-radius: 6px;
    outline: none;
    line-height: 24px;
}

/* Button */
.coupon_generateBtn__NSFCb {
    padding: 8px 12px;
    margin-top: 5px;
    border: 1px solid var(--bg-green);
    background: #fff;
    color: var(--bg-green);
    border-radius: 4px;
    cursor: pointer;
    white-space: nowrap;
    font-size: 14px;
    outline: none;
    max-width: max-content;
}

.coupon_description__98QmB {
    width: 100%;
    min-height: 80px;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 16px;
    resize: vertical;
    margin-top: 10px;
    outline: none;
    font-family: 'CyGrotesk-KeyRegular';
}

.coupon_description__98QmB::placeholder {
    font-size: 20px;
    color: #999;
}

.coupon_inputField__IMo19 {
    display: flex;
    flex-direction: column;
}

.coupon_couponDataWrapper__lvdJM {
    display: flex;
    border: 1px solid #ddd;
    background: #fff;
    position: relative;
}

.coupon_couponDataSidebar__02Rew {
    width: 200px;
    border: 1px solid #f1f1f1;
    background: var(--white);
    transition: transform 0.3s ease;
}

.coupon_sidebarOpen__IqvJ5 {
    transform: translateX(0);
}

.coupon_sidebarClosed__WIYhG {
    transform: translateX(-120%);
}

.coupon_closeSidebar__L1jQk {
    position: absolute;
    top: 10px;
    right: 10px;
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
    color: #333;
}

.coupon_couponDataDetailBox__7wSBW{
    width: 100%;
}

.coupon_label__q7TAD{
    max-width: 200px;
    width: 100%;
}

.coupon_hamburgerMenu__0DyUY {
    display: none;
}

.coupon_hamburgerMenuIcon__1mIvF {
    position: absolute;
    width: 18px;
    height: 20px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
    top: 20px;
    right: 15px;
}

.coupon_hamburgerMenuIcon__1mIvF span {
    height: 2px;
    width: 100%;
    background: #667085;
    border-radius: 2px;
    transition: 0.3s ease;
}

.coupon_hamburgerMenuIcon__1mIvF.coupon_open__uVvCz span:nth-child(1) {
    transform: translateY(6px) rotate(45deg);
}

.coupon_hamburgerMenuIcon__1mIvF.coupon_open__uVvCz span:nth-child(2) {
    opacity: 0;
}

.coupon_hamburgerMenuIcon__1mIvF.coupon_open__uVvCz span:nth-child(3) {
    transform: translateY(-6px) rotate(-45deg);
}

.coupon_sidebarToggle__bg1wE {
    display: none;
    position: absolute;
    top: 10px;
    right: 10px;
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
    color: #333;
}

.coupon_couponDataOption__B-wQb {
    display: block;
    width: 100%;
    text-align: left;
    padding: 15px;
    border: none;
    background: none;
    cursor: pointer;
    color: var(--bg-green);
    font-size: 16px;
    font-weight: 500;
    border-bottom: 1px solid #ddd;
}

.coupon_couponDataOption__B-wQb.coupon_activeTab__51XMk {
    background-color: #dddddd6b;
}

.coupon_generalContainer__Pj2ot {
    padding: 20px 15px;
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.coupon_discountType__AB6IN {
    display: flex;
}

.coupon_couponAmount__Iw5qD {
    width: 240px;
    border: 1px solid #ddd;
    padding: 10px 14px;
    border-radius: 6px;
    outline: none;
    font-size: 16px;
}

.coupon_expiryDate__520ZH {
    width: 240px;
    border: 1px solid #ddd;
    padding: 10px 14px;
    border-radius: 6px;
    outline: none;
    font-size: 16px;
    cursor: pointer;
}

.coupon_leftSide__C8WOZ{
    display: flex;
    gap: 20px;
}

.coupon_deleteSelectedBtn__7WWeR{
    cursor: pointer;
}

.coupon_saveButton__UBmm1 button{
    width: 71.41px;
    height: 39px;
}

@media screen and (max-width: 768px) {

    .coupon_actionButtonsDeleteAdd__388aa {
        justify-content: space-between;
        width: 100%;
    }

    .coupon_searchBar__YAsTt,
    .coupon_leftSide__C8WOZ {
        width: 100%;
        min-width: 100%;
    }

    .coupon_couponDataSidebar__02Rew {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        z-index: 10;
    }

    .coupon_sidebarToggle__bg1wE {
        display: block;
    }

    .coupon_couponDataDetailBox__7wSBW {
        position: relative;
        width: 100%;
    }

    .coupon_discountType__AB6IN {
        flex-direction: column;
        align-items: baseline;
        gap: 10px;
    }

    .coupon_hamburgerMenu__0DyUY {
        display: flex;
        justify-content: end;
    }

    .coupon_searchBar__YAsTt,
    .coupon_leftSide__C8WOZ {
        width: calc(100% - 50px);
        min-width: calc(100% - 50px)
    }

}

@media screen and (min-width: 768px) {

    .coupon_couponDataSidebar__02Rew {
        transform: translateX(0) !important;
    }

    .coupon_closeSidebar__L1jQk {
        display: none;
    }

    .coupon_sidebarToggle__bg1wE {
        display: none;
    }

}`, "",{"version":3,"sources":["webpack://./src/Pages/Coupon/coupon.module.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,QAAQ;IACR,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,SAAO;IACP,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,iBAAiB;AACrB;;AAEA,WAAW;AACX;IACI,iBAAiB;IACjB,eAAe;IACf,iCAAiC;IACjC,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,mCAAmC;AACvC;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,wBAAwB;IACxB,+BAA+B;AACnC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,UAAU;IACV,SAAS;IACT,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;;IAEI;QACI,8BAA8B;QAC9B,WAAW;IACf;;IAEA;;QAEI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,OAAO;QACP,MAAM;QACN,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,qBAAqB;QACrB,SAAS;IACb;;IAEA;QACI,aAAa;QACb,oBAAoB;IACxB;;IAEA;;QAEI,wBAAwB;QACxB;IACJ;;AAEJ;;AAEA;;IAEI;QACI,mCAAmC;IACvC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;AAEJ","sourcesContent":[".couponDatatableList {\n    padding: 30px 30px 0;\n}\n\n.couponHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.couponHeader .couponHeading {\n    font-size: 20px;\n    font-weight: 600;\n}\n\n.actionButtonsDeleteAdd {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 10px;\n}\n\n.couponHeader .leftSide {\n    display: flex;\n    gap: 20px;\n}\n\n.searchBar {\n    display: flex;\n    align-items: center;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    padding: 8px 12px;\n    gap: 8px;\n    min-width: 250px;\n    height: 40px;\n}\n\n.searchBar img {\n    width: 16px;\n    height: 16px;\n}\n\n.searchBar input {\n    border: none;\n    background: transparent;\n    outline: none;\n    flex: 1;\n    font-size: 14px;\n    color: #333;\n}\n\n.searchBar input::placeholder {\n    color: #999;\n}\n\n.addCouponContainer {\n    padding: 25px 25px 0;\n    display: flex;\n    flex-direction: column;\n    gap: 25px;\n    height: 100vh;\n}\n\n.couponGenerateSection {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: column;\n    gap: 5px;\n    width: 100%;\n}\n\n.couponInput {\n    width: 100%;\n    padding: 10px;\n    font-size: 16px;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    outline: none;\n    line-height: 24px;\n}\n\n/* Button */\n.generateBtn {\n    padding: 8px 12px;\n    margin-top: 5px;\n    border: 1px solid var(--bg-green);\n    background: #fff;\n    color: var(--bg-green);\n    border-radius: 4px;\n    cursor: pointer;\n    white-space: nowrap;\n    font-size: 14px;\n    outline: none;\n    max-width: max-content;\n}\n\n.description {\n    width: 100%;\n    min-height: 80px;\n    padding: 10px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 16px;\n    resize: vertical;\n    margin-top: 10px;\n    outline: none;\n    font-family: 'CyGrotesk-KeyRegular';\n}\n\n.description::placeholder {\n    font-size: 20px;\n    color: #999;\n}\n\n.inputField {\n    display: flex;\n    flex-direction: column;\n}\n\n.couponDataWrapper {\n    display: flex;\n    border: 1px solid #ddd;\n    background: #fff;\n    position: relative;\n}\n\n.couponDataSidebar {\n    width: 200px;\n    border: 1px solid #f1f1f1;\n    background: var(--white);\n    transition: transform 0.3s ease;\n}\n\n.sidebarOpen {\n    transform: translateX(0);\n}\n\n.sidebarClosed {\n    transform: translateX(-120%);\n}\n\n.closeSidebar {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    background: none;\n    border: none;\n    font-size: 20px;\n    cursor: pointer;\n    color: #333;\n}\n\n.couponDataDetailBox{\n    width: 100%;\n}\n\n.label{\n    max-width: 200px;\n    width: 100%;\n}\n\n.hamburgerMenu {\n    display: none;\n}\n\n.hamburgerMenuIcon {\n    position: absolute;\n    width: 18px;\n    height: 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    padding: 0;\n    top: 20px;\n    right: 15px;\n}\n\n.hamburgerMenuIcon span {\n    height: 2px;\n    width: 100%;\n    background: #667085;\n    border-radius: 2px;\n    transition: 0.3s ease;\n}\n\n.hamburgerMenuIcon.open span:nth-child(1) {\n    transform: translateY(6px) rotate(45deg);\n}\n\n.hamburgerMenuIcon.open span:nth-child(2) {\n    opacity: 0;\n}\n\n.hamburgerMenuIcon.open span:nth-child(3) {\n    transform: translateY(-6px) rotate(-45deg);\n}\n\n.sidebarToggle {\n    display: none;\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    background: none;\n    border: none;\n    font-size: 20px;\n    cursor: pointer;\n    color: #333;\n}\n\n.couponDataOption {\n    display: block;\n    width: 100%;\n    text-align: left;\n    padding: 15px;\n    border: none;\n    background: none;\n    cursor: pointer;\n    color: var(--bg-green);\n    font-size: 16px;\n    font-weight: 500;\n    border-bottom: 1px solid #ddd;\n}\n\n.couponDataOption.activeTab {\n    background-color: #dddddd6b;\n}\n\n.generalContainer {\n    padding: 20px 15px;\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n}\n\n.discountType {\n    display: flex;\n}\n\n.couponAmount {\n    width: 240px;\n    border: 1px solid #ddd;\n    padding: 10px 14px;\n    border-radius: 6px;\n    outline: none;\n    font-size: 16px;\n}\n\n.expiryDate {\n    width: 240px;\n    border: 1px solid #ddd;\n    padding: 10px 14px;\n    border-radius: 6px;\n    outline: none;\n    font-size: 16px;\n    cursor: pointer;\n}\n\n.leftSide{\n    display: flex;\n    gap: 20px;\n}\n\n.deleteSelectedBtn{\n    cursor: pointer;\n}\n\n.saveButton button{\n    width: 71.41px;\n    height: 39px;\n}\n\n@media screen and (max-width: 768px) {\n\n    .actionButtonsDeleteAdd {\n        justify-content: space-between;\n        width: 100%;\n    }\n\n    .searchBar,\n    .leftSide {\n        width: 100%;\n        min-width: 100%;\n    }\n\n    .couponDataSidebar {\n        position: absolute;\n        left: 0;\n        top: 0;\n        height: 100%;\n        z-index: 10;\n    }\n\n    .sidebarToggle {\n        display: block;\n    }\n\n    .couponDataDetailBox {\n        position: relative;\n        width: 100%;\n    }\n\n    .discountType {\n        flex-direction: column;\n        align-items: baseline;\n        gap: 10px;\n    }\n\n    .hamburgerMenu {\n        display: flex;\n        justify-content: end;\n    }\n\n    .searchBar,\n    .leftSide {\n        width: calc(100% - 50px);\n        min-width: calc(100% - 50px)\n    }\n\n}\n\n@media screen and (min-width: 768px) {\n\n    .couponDataSidebar {\n        transform: translateX(0) !important;\n    }\n\n    .closeSidebar {\n        display: none;\n    }\n\n    .sidebarToggle {\n        display: none;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"couponDatatableList": `coupon_couponDatatableList__ys2nO`,
	"couponHeader": `coupon_couponHeader__zzawK`,
	"couponHeading": `coupon_couponHeading__GSuK1`,
	"actionButtonsDeleteAdd": `coupon_actionButtonsDeleteAdd__388aa`,
	"leftSide": `coupon_leftSide__C8WOZ`,
	"searchBar": `coupon_searchBar__YAsTt`,
	"addCouponContainer": `coupon_addCouponContainer__8N13N`,
	"couponGenerateSection": `coupon_couponGenerateSection__4Q86h`,
	"couponInput": `coupon_couponInput__sNX7B`,
	"generateBtn": `coupon_generateBtn__NSFCb`,
	"description": `coupon_description__98QmB`,
	"inputField": `coupon_inputField__IMo19`,
	"couponDataWrapper": `coupon_couponDataWrapper__lvdJM`,
	"couponDataSidebar": `coupon_couponDataSidebar__02Rew`,
	"sidebarOpen": `coupon_sidebarOpen__IqvJ5`,
	"sidebarClosed": `coupon_sidebarClosed__WIYhG`,
	"closeSidebar": `coupon_closeSidebar__L1jQk`,
	"couponDataDetailBox": `coupon_couponDataDetailBox__7wSBW`,
	"label": `coupon_label__q7TAD`,
	"hamburgerMenu": `coupon_hamburgerMenu__0DyUY`,
	"hamburgerMenuIcon": `coupon_hamburgerMenuIcon__1mIvF`,
	"open": `coupon_open__uVvCz`,
	"sidebarToggle": `coupon_sidebarToggle__bg1wE`,
	"couponDataOption": `coupon_couponDataOption__B-wQb`,
	"activeTab": `coupon_activeTab__51XMk`,
	"generalContainer": `coupon_generalContainer__Pj2ot`,
	"discountType": `coupon_discountType__AB6IN`,
	"couponAmount": `coupon_couponAmount__Iw5qD`,
	"expiryDate": `coupon_expiryDate__520ZH`,
	"deleteSelectedBtn": `coupon_deleteSelectedBtn__7WWeR`,
	"saveButton": `coupon_saveButton__UBmm1`
};
export default ___CSS_LOADER_EXPORT___;
